// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { ChangeEvent } from "react";

import { CategoryDocument } from "../store/schema";
import { UID_NEW } from "../util";

interface CategoryChooserProps {
  htmlId?: string;
  categories: CategoryDocument[];
  uid: string;
  onChangeCategory: (uid: string) => void;
}

export const CategoryChooser: React.FC<CategoryChooserProps> = ({
  htmlId,
  categories,
  uid,
  onChangeCategory,
}) => {
  function onChange(e: ChangeEvent<HTMLSelectElement>) {
    const uid = e.target.value;
    debug(`chose category ${uid}`);
    onChangeCategory(uid);
  }

  debug(`categoryUid=${uid}`);
  const headerDoc = {
    uid: "",
    data: { uid: UID_NEW, name: "<Choose a category>" },
  };
  const choices = [headerDoc, ...sortedCategories(categories)];
  return (
    <select id={htmlId} onChange={onChange} value={uid}>
      {choices.map(x => (
        <option key={x.data.uid} value={x.data.uid}>
          {x.data.name}
        </option>
      ))}
    </select>
  );
};

function sortedCategories(cats: CategoryDocument[]): CategoryDocument[] {
  return [...cats].sort(compareCategories);
}

function compareCategories(a: CategoryDocument, b: CategoryDocument): number {
  const aSort = a.data.sortOverride || 0;
  const bSort = b.data.sortOverride || 0;
  if (aSort < bSort) return -1;
  if (aSort > bSort) return 1;

  const aName = a.data.name;
  const bName = b.data.name;
  if (aName < bName) return -1;
  if (aName > bName) return 1;

  return 0;
}

function debug(message: string) {
  if (true) {
    console.log(`CategoryChooser: ${message}`);
  }
}
